import React from "react";

const Footer = () => (
  <footer className="absolute bottom-0 w-full bg-gray-800 text-white p-4 text-center">
    <p>&copy; 2025 AKMAKE.IN. All rights reserved.</p>
  </footer>
);


export default Footer;
